import { AuthProvider } from './../auth/auth';
import { HttpClient } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV } from '../../environments/environment';
import { UtilsProvider } from '../utils/utils';

@Injectable()
export class UserProvider {
  private providers: Provider[]; // PROVIDERS
  private users: any;
  constructor(public http: HttpClient, private authProvider: AuthProvider, private utilsProvide: UtilsProvider) {}

  getUsers(force = true) {
      return Observable.create(observer => {
        if(this.users && force === false){
          observer.next(this.users);
        } else {

        this.authProvider.getOptions().subscribe(options => {

            const api = ENV.api + '/api/users';
            const obj = {
              sort: 'userName',
              companies: this.authProvider.userData.data.companies
            }
            this.http.put(api, obj, options).subscribe(
                result => {
                  this.users = result;
                  observer.next(result);
                },
                error => {
                  observer.error(error);
                }
              );
          });
        }
      });

  }

  updateUser(obj) {
    const id: string = obj.uid;
    if (obj.role) delete obj.role;
    return Observable.create(observer => {
      this.authProvider.getOptions().subscribe(options => {
        const api = ENV.api + '/api/users/' + id;
        if(obj.image && obj.image.includes('https://')) obj.image = obj.image.replace("https://", '')
        this.http.put(api, obj, options).subscribe(
          result => {
            observer.next(result);
          },
          error => {
            observer.error({ message: 'API error' });
          }
        );
      });
    });
  }

}




// WEBPACK FOOTER //
// ./src/providers/users/users.ts